const connectRHControl = () => {
  const hr = document.getElementById('hrSelected')
  const hr2 = document.getElementById('hrSelectedRh')

  if (!hr || !hr2) return

  document.querySelector('[data-sc-field-name="Sector"]').onchange = (event) => {
    const { value } = event.target.value

    if (value === 'Human Resources' || value === 'Recursos Humanos' || value === '人力资源') {
      hr.style.display = 'none'
      hr2.style.display = 'block'
    } else {
      hr.style.display = 'block'
      hr2.style.display = 'none'
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const label = document.querySelector('.js-terms')
  const errorInputList = document.querySelectorAll('.field-validation-error')

  connectRHControl()

  for (let i = 0; i < errorInputList.length; i++) {
    const testddd = errorInputList[i]
    testddd.previousElementSibling.classList.add('input-error')
  }

  if (!label) {
    return
  }

  const checkbox = label.querySelector('input[type="checkbox"]')
  const hidden = label.querySelector('input[type="hidden"]')

  if (!checkbox || !hidden) {
    return
  }

  const { innerText } = label.innerText
  const anchor = document.createElement('a')

  anchor.text = innerText.trim()
  anchor.href = checkbox.getAttribute('class')
  anchor.target = '_blank'

  label.innerHTML = ''

  label.appendChild(checkbox)
  label.appendChild(hidden)
  label.appendChild(anchor)
})
